import {ReactComponent as FacebookIcon} from '../../assets/icons/rrss/facebook-original.svg';
import {ReactComponent as TwitterIcon} from '../../assets/icons/rrss/twitter-original.svg';
import {ReactComponent as LinkedinIcon} from '../../assets/icons/rrss/linkedin-original.svg';
import {ReactComponent as WhatsappIcon} from '../../assets/icons/rrss/whatsapp-original.svg';

export const socialNetworkLinks = [
    {
        title: 'Facebook',
        link: 'https://www.facebook.com/share.php?u=https://visorbicicleta.amb.cat',
        icon: FacebookIcon,
    },
    {
        title: 'Twitter',
        link: 'https://twitter.com/intent/tweet?url=https://visorbicicleta.amb.cat',
        icon: TwitterIcon,
    },
    {
        title: 'LinkedIn',
        link: 'https://www.linkedin.com/cws/share?url=https://visorbicicleta.amb.cat',
        icon: LinkedinIcon,
    },
    {
        title: 'WhatsApp',
        link: 'https://api.whatsapp.com/send?text=https://visorbicicleta.amb.cat',
        icon: WhatsappIcon,
    },
];
